import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// popupus
import CreateProject from "./CreateProject";

// styles and images
import "./Dashboard.css";
import Add from "../../assets/add.svg";

// internal hooks
import { useGetProjectDD } from "../../hooks/useGetProjectDD";

// components
import ProjectListAlt from "./ProjectListAlt";
import ProjectFilter from "./ProjectFilter";

// store
import { dbDataStore, messageAndErrorStore, userStore } from "../../store/Store";

export default function Dashboard() {
  // global state
  const JwtToken = userStore((userDataStore) => userDataStore.JwtToken);
  const currentUser = userStore((userDataStore) => userDataStore.currentUser);
  const projectData = dbDataStore((dbData) => dbData.projectData);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const toggleNewMessage = messageAndErrorStore(data => data.toggleNewMessage)
  
  // triggers
  const [isTriggered, setIsTriggered] = useState(false);

  // state
  const [visibleProjects, setVisibleProjects] = useState(null);
  const { dropDowns } = useGetProjectDD();
  const navigate = useNavigate();

  useEffect(() => {
    if (projectData && !projectData.error) {
      let vis = [];
      projectData.forEach((p) => {
        if (!p.archived) {
          vis.push(p);
        }
      });
      setVisibleProjects(vis);
    }
  }, [projectData, navigate]);

  const handleDownload = () => {
    const controller = new AbortController();
    const headers = new Headers();
    headers.append("Authorization", "Bearer " + JwtToken);
    headers.append("Content-Type", "text/csv");
    const requestOptions = {
      method: "GET",
      headers,
      signal: controller.signal,
    };
    fetch(
      `${process.env.REACT_APP_BACKEND}/lc/get-file/FSC_Template.csv/templates/csv?user_id=${currentUser.id}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            setAuthStatus(false);
            navigate("/login");
          } else {
            toggleNewMessage("Could not download file");
          }
        } else {
          return response.blob();
        }
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        let alink = document.createElement("a");
        alink.href = url;
        alink.download = "FSC_Template.csv";
        alink.click();
      })
      .catch((_) => {
        toggleNewMessage("Something went wrong");
        return;
      });
    return () => controller.abort();
  };

  return (
    JwtToken && (
      <div className="container-fluid">
        <div className="d-flex justify-content-between dashboard-header">
          <h1>Projects</h1>
          <div className="button-div">
            <button className="btn btn-secondary" onClick={handleDownload}>
              Download FSC Template
            </button>
            <img
              src={Add}
              alt="add"
              onClick={() => setIsTriggered(true)}
              className="project-delete-image"
            />
          </div>
        </div>
        {isTriggered && (
          <CreateProject
            setIsTriggered={setIsTriggered}
            isTriggered={isTriggered}
            dropDowns={dropDowns}
          />
        )}
        {projectData && !projectData.error ? (
          <div className="row g-2">
            <ProjectFilter
              setVisibleProjects={setVisibleProjects}
              projectDocs={projectData}
            />
            <ProjectListAlt projectDocs={visibleProjects} />
          </div>
        ) : (
          !projectData && (
            <p className="no-docs-added">No Projects Have Been Added</p>
          )
        )}
      </div>
    )
  );
}
